import Entity from '../entity'
export default class Holiday extends Entity<number>{
    name: string = "";
    holidayType:number = 0;
    startDate: Date = new Date();
    endDate: Date = new Date();
}